"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RffWrapper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFinalForm = require("react-final-form");

var passSubmitting = function passSubmitting(eleName, submitting) {
  if (eleName === 'MuiSubmit' || eleName === 'HTMLSubmit') {
    return submitting;
  }

  return submitting.toString();
};

var RffWrapper = function RffWrapper(_ref) {
  var children = _ref.children,
      debug = _ref.debug,
      initialValues = _ref.initialValues,
      initialValuesEqual = _ref.initialValuesEqual,
      keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize,
      onSubmit = _ref.onSubmit,
      subscription = _ref.subscription,
      validate = _ref.validate,
      validateOnBlur = _ref.validateOnBlur,
      mutators = _ref.mutators;
  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Form, {
    debug: debug,
    initialValues: initialValues,
    initialValuesEqual: initialValuesEqual,
    keepDirtyOnReinitialize: keepDirtyOnReinitialize,
    onSubmit: onSubmit,
    subscription: subscription,
    validate: validate,
    validateOnBlur: validateOnBlur,
    mutators: mutators
  }, function (_ref2) {
    var handleSubmit = _ref2.handleSubmit,
        submitting = _ref2.submitting,
        form = _ref2.form;
    return /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Array.isArray(children) && children.map(function (child, key) {
      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        key: key,
        submitting: passSubmitting(child.type.name, submitting),
        form: form
      });
    }), !Array.isArray(children) && /*#__PURE__*/(0, _react.cloneElement)(children, {
      submitting: passSubmitting(children.type.name, submitting),
      form: form
    })));
  });
};

exports.RffWrapper = RffWrapper;
var _default = RffWrapper; // https://final-form.org/docs/react-final-form/types/FormProps

exports.default = _default;
RffWrapper.propTypes = {
  /**
   * A render function that is given FormRenderProps,
    as well as any non-API props passed into the <Form/> component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Function to call when the form is submitted.
    There are three possible ways to write an onSubmit function:
   */
  onSubmit: _propTypes.default.func.isRequired,

  /**
   * A callback for debugging that receives the form state and the states of all the fields.
    It's called on every state change. A typical thing to pass in might be console.log.
   */
  debug: _propTypes.default.func,

  /**
   * The initial values of your form.
    These will also be used to compare against the current values to calculate pristine and dirty.
   */
  initialValues: _propTypes.default.shape(),

  /**
   * A predicate to determine whether or not the initialValues prop has changed, i.e. to know if the
    form needs to be reinitialized with the new values. Useful for passing in a "deep equals"
    function if you need to. Defaults to "shallow equals".
   */
  initialValuesEqual: _propTypes.default.bool,

  /**
   * If true, only pristine values will be overwritten when initialize(newValues) is called.
    This can be useful for allowing a user to continue to edit a record while the record is
    being saved asynchronously, and the form is reinitialized to the saved values when the save
    is successful. Defaults to false.
   */
  keepDirtyOnReinitialize: _propTypes.default.bool,

  /**
   * An object of the parts of FormState to subscribe to. If a subscription is provided, the
    <Form/> will only rerender when those parts of form state change. If no subscription is provided
    it will default to subscribing to all form state changes. i.e.<Form/> will rerender whenever any
    part of the form state changes.
   * ex : { [string]: boolean }
    */
  subscription: _propTypes.default.shape(),

  /**
   * ex: (values: FormValues) => Object | Promise<Object>
   * A whole-record validation function that takes all the values of the form and returns any
    validation errors. There are two possible ways to write a validate function:
   */
  validate: _propTypes.default.func,

  /**
   * If true, validation will happen on blur. If false, validation will happen on change.
   * Defaults to false.
   */
  validateOnBlur: _propTypes.default.bool,

  /**
   * Optional.
   * Named mutator functions.
   */
  mutators: _propTypes.default.shape()
};
RffWrapper.defaultProps = {
  debug: undefined,
  initialValues: {},
  initialValuesEqual: false,
  keepDirtyOnReinitialize: false,
  subscription: undefined,
  validate: undefined,
  validateOnBlur: false,
  mutators: undefined
};